import { getCSS } from '@gimlite/common';
import classNames from 'classnames';
import React, { memo } from 'react';
import { ColorType } from '../../types/component.type';
import { Text } from '../text/text.component';
import './alert.component.scss';

const variantMapper = {
  alert_error: {
    backgroundColor: 'alert_error',
    color: 'white_100',
  },
  alert_warning: {
    backgroundColor: 'alert_warning',
    color: 'white_100',
  },
  alert_success: {
    backgroundColor: 'alert_success',
    color: 'white_100',
  },
  alert_info: {
    backgroundColor: 'alert_info',
    color: 'white_100',
  },
  alert_advisory: {
    backgroundColor: 'alert_advisory',
    color: 'white_100',
  },
  black_15: {
    backgroundColor: 'black_15',
    color: 'deep_indigo',
  },
  black_50: {
    backgroundColor: 'black_50',
    color: 'white_100',
  },
  black_90: {
    backgroundColor: 'black_90',
    color: 'white_100',
  },
} as const satisfies Record<
  string,
  { backgroundColor: ColorType; color: ColorType }
>;

export declare namespace AlertType {
  type Props = {
    className?: string | null;
    children?: React.ReactNode | null;
    variant?: keyof typeof variantMapper;
  };
}

export const Alert = memo(
  ({ children, className, variant = 'alert_info' }: AlertType.Props) => {
    const { backgroundColor, color } = variantMapper[variant];
    return (
      <div
        style={{
          backgroundColor: getCSS(`--color-${backgroundColor}`),
        }}
        className={classNames('alert', className)}
      >
        <Text
          whiteSpace="nowrap"
          textTransform="uppercase"
          variant="sublabel"
          color={color}
        >
          {children}
        </Text>
      </div>
    );
  },
);
